import { render, staticRenderFns } from "./CorrectionSection.vue?vue&type=template&id=9aa1fa56&"
import script from "./CorrectionSection.vue?vue&type=script&lang=js&"
export * from "./CorrectionSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports